import React from 'react'

export default function AboutEmotion() {
  return (
    <>
    <section className="aboutpage-emotion">
        <div className="container">
            <div className="row align-items-center">

                <div className="col-lg-5 col-md-5 order-2 order-md-1 order-lg-1">
                    <img src="/image/sonam.webp" className="img-responsive" alt="about" loading="lazy"/>
                </div>

                <div className="col-lg-7 col-md-7 order-1 order-md-2 order-lg-2">
                    <div className="aboutemotion-text wow animate__animated animate__fadeInUp" data-wow-duration="1s" data-wow-delay="0.1s">
                        <h4 className="heading">Bespoke Emotions</h4>
                        <p className='gradient-color'>“Emotion is the first stitch - everything else follows.”</p>
                        
                        <p>Sonam designs with a rare combination of intuition and intention, driven by a desire to create pieces that feel personal, soulful, and truly unforgettable. Her techniques are rooted in precision, patience, and a deep respect for the moments her work becomes part of. As an upcoming luxury couturier, she chooses to remain selectively available, allowing her to pour undivided attention into every bride she works with.</p>

                        <p>This exclusivity is not about rarity - it is about responsibility. Every ensemble that leaves her studio carries the weight of her dedication, her vision, and her unwavering belief that luxury is not loud, but deeply felt. Each creation stands as a testament to her craft: thoughtful, intimate, and shaped by a love for the work that speaks louder than any introduction ever could.</p>
                    </div>
                </div>

            </div>
        </div>
    </section>
    </>
  )
}
